var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16.4c-4.1 0-7.4-3.3-7.4-7.4S7.9 4.6 12 4.6s7.4 3.3 7.4 7.4-3.3 7.4-7.4 7.4zm3-5.5c.3.3.3.8 0 1.1-.2.2-.4.2-.5.2-.2 0-.4-.1-.5-.2l-2.4-2.4c-.2-.1-.2-.3-.2-.5V7.4c0-.4.4-.8.8-.8s.8.4.8.8v4.3l2 2.2z"
  })));
}

export default SvgClock;